import { FavoriteStoreSearch } from './favorite-store-search';

export default FavoriteStoreSearch;
